import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { EntityUnionType } from 'common/types/entities/EntityInterface'
import ServerPage from 'server/types/ServerPageInterface'

//run the command only on page level, not on layout

export const removeDuplicatedBlogPostLayoutBody = (
  page: ServerPage,
): [ServerPage, boolean] => {

  if(page.type !==PageTypeEnum.BlogPostBody) return [page, false]

  let hasChanged = false

  const newEntities: Record<string, EntityUnionType> = {}

  Object.values(page.content.entities).forEach(entity => {
    if (
      entity.type === EntityTypeEnum.BlogPostLayoutBody &&
      !('isReadOnly' in entity) 
    ) {
      hasChanged = true
      return
    }

    newEntities[entity.id] = entity
  })

  return [
    {
      ...page,
      content: {
        ...page.content,
        entities: newEntities,
      },
    },
    hasChanged,
  ]
}
